// extracted by css-extract-rspack-plugin
module.exports =  {"root":"b870035d7c","hideTopSpacing":"d8cfa4b87f"};